/* KiekkoKingi Seuroille-sivu: säästölaskuri, liidiseuranta, lomakkeen aihe ja mobiilin alapalkki.
   Ladataan vain sektioissa kiekkokingi-partner-calculator ja kiekkokingi-partner-join (defer). */
(() => {
  if (window.kkPartner) return;

  const fmt = (n) => Math.round(n).toLocaleString('fi-FI').replace(/\s/g, ' ');

  // Seuranta: Shopifyn customer events -> custom pixel välittää GA4:lle ja Metalle. Ei koskaan estä käyttöliittymää.
  const track = (name, params = {}) => {
    try { window.Shopify?.analytics?.publish?.(`kk_partner_${name}`, params); } catch (e) {}
    try { window.gtag?.('event', name, params); } catch (e) {}
  };

  function initCalc(root) {
    if (root.dataset.kkInit) return;
    root.dataset.kkInit = '1';
    const n = (k) => Number(root.dataset[k]) || 0;
    const d = {
      pct: { h: n('pctHopea'), k: n('pctKulta'), p: n('pctPlatina') },
      name: { h: root.dataset.nameHopea, k: root.dataset.nameKulta, p: root.dataset.namePlatina },
      tK: n('tKulta'), tP: n('tPlatina'),
      pkg: { c: n('pkgC'), b: n('pkgB'), a: n('pkgA') },
      min: { c: n('minC'), b: n('minB'), a: n('minA') },
    };
    const cnt = { c: n('c'), b: n('b'), a: n('a') };
    const $ = (s) => root.querySelector(s);
    const sum = $('[data-kk-sum]');
    const range = $('[data-kk-range]');
    const out = (k) => $(`[data-kk-out="${k}"]`);
    let used = false;
    const firstUse = () => { if (!used) { used = true; track('calculator_use', { section: 'partner_calculator' }); } };

    function calc() {
      const p = Math.max(0, Math.min(1000000, parseInt(String(sum.value).replace(/\D/g, ''), 10) || 0));
      const disc = (Math.min(p, d.tK) * d.pct.h
        + Math.max(0, Math.min(p, d.tP) - d.tK) * d.pct.k
        + Math.max(0, p - d.tP) * d.pct.p) / 100;
      const pkg = cnt.c * d.pkg.c + cnt.b * d.pkg.b + cnt.a * d.pkg.a;
      const need = cnt.c * d.min.c + cnt.b * d.min.b + cnt.a * d.min.a;
      const tier = p > d.tP ? `${d.name.p} ${d.pct.p}%` : p > d.tK ? `${d.name.k} ${d.pct.k}%` : `${d.name.h} ${d.pct.h}%`;
      out('disc').textContent = `${root.dataset.approx || 'noin'} ${fmt(disc)} €`;
      out('pkg').textContent = `${fmt(pkg)} €`;
      out('tier').textContent = tier;
      out('total').textContent = `${root.dataset.approx || 'noin'} ${fmt(Math.round(disc) + pkg)} €`;
      const w = out('warn');
      w.hidden = need <= p;
      if (need > p) w.textContent = (root.dataset.warn || '').replace('[summa]', fmt(need));
      return p;
    }

    sum.addEventListener('input', () => { range.value = Math.min(Number(range.max), calc()); firstUse(); });
    sum.addEventListener('blur', () => { sum.value = fmt(calc()); });
    sum.addEventListener('focus', () => sum.select());
    range.addEventListener('input', () => { sum.value = fmt(range.value); calc(); firstUse(); });
    root.querySelectorAll('[data-kk-stepper]').forEach((s) => {
      const k = s.dataset.kkStepper;
      const o = s.querySelector('output');
      const step = (delta) => { cnt[k] = Math.max(0, Math.min(20, cnt[k] + delta)); o.textContent = cnt[k]; calc(); firstUse(); };
      s.querySelector('[data-kk-dec]').addEventListener('click', () => step(-1));
      s.querySelector('[data-kk-inc]').addEventListener('click', () => step(1));
    });
    calc();
  }

  function initForm(form) {
    if (form.dataset.kkInit) return;
    form.dataset.kkInit = '1';
    form.addEventListener('submit', () => {
      const subject = form.querySelector('[data-kk-subject]');
      const org = form.querySelector('[data-kk-org]');
      if (subject && org && org.value.trim()) subject.value = `${subject.dataset.kkSubject}: ${org.value.trim()}`;
    });
  }

  function initSuccess(el) {
    if (el.dataset.kkInit) return;
    el.dataset.kkInit = '1';
    const name = el.dataset.kkLeadSuccess || 'kumppani_2027';
    // Sama lähetys lasketaan kerran, vaikka sivu ladattaisiin uudelleen.
    let seen = false;
    try { seen = sessionStorage.getItem('kk_partner_lead') === location.search; sessionStorage.setItem('kk_partner_lead', location.search); } catch (e) {}
    if (!seen) track('lead', { form: name });
    el.focus({ preventScroll: true });
  }

  function initSticky(bar) {
    if (bar.dataset.kkInit) return;
    bar.dataset.kkInit = '1';
    const join = document.querySelector('[data-kk-join]');
    if (!join || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(([entry]) => bar.classList.toggle('is-hidden', entry.isIntersecting), { rootMargin: '0px 0px -20% 0px' }).observe(join);
  }

  function boot() {
    document.querySelectorAll('[data-kk-calc]').forEach(initCalc);
    document.querySelectorAll('form[data-kk-form]').forEach(initForm);
    document.querySelectorAll('[data-kk-lead-success]').forEach(initSuccess);
    document.querySelectorAll('[data-kk-sticky]').forEach(initSticky);
  }

  document.addEventListener('click', (e) => {
    const cta = e.target.closest('[data-kk-cta]');
    if (cta) return track('cta_click', { cta_location: cta.dataset.kkCta });
    const link = e.target.closest('[data-kk-track]');
    if (link) track(link.dataset.kkTrack.replace(/^partner_/, ''), { href: link.getAttribute('href') });
  });
  document.addEventListener('shopify:section:load', boot);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.kkPartner = { track };
})();
